import {ITimeEntryTypeVm} from "../Data/Data";

export class TimeEntryDialog {
  open(callback: (timeEntry: ITimeEntryTypeVm) => void) {

  }
}